var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 6.99992C0.333496 3.31792 3.31816 0.333252 7.00016 0.333252C10.6822 0.333252 13.6668 3.31792 13.6668 6.99992C13.6668 10.6819 10.6822 13.6666 7.00016 13.6666C3.31816 13.6666 0.333496 10.6819 0.333496 6.99992ZM7.66683 3.66659C7.66683 3.48977 7.59659 3.32021 7.47157 3.19518C7.34654 3.07016 7.17697 2.99992 7.00016 2.99992C6.82335 2.99992 6.65378 3.07016 6.52876 3.19518C6.40373 3.32021 6.3335 3.48977 6.3335 3.66659V6.17592C6.33351 6.54729 6.43692 6.91131 6.63214 7.22723C6.82737 7.54314 7.10669 7.79846 7.43883 7.96459L9.36883 8.92925C9.44741 8.97163 9.53371 8.99779 9.6226 9.00618C9.71148 9.01457 9.80115 9.00502 9.88628 8.9781C9.9714 8.95118 10.0503 8.90744 10.1182 8.84946C10.1861 8.79149 10.2416 8.72046 10.2815 8.64061C10.3215 8.56075 10.345 8.47369 10.3506 8.38459C10.3562 8.29548 10.3439 8.20615 10.3144 8.1219C10.2848 8.03764 10.2387 7.96018 10.1786 7.89411C10.1186 7.82803 10.0459 7.77469 9.96483 7.73725L8.0355 6.77192C7.92478 6.71659 7.83164 6.63153 7.76653 6.52627C7.70142 6.42101 7.6669 6.29969 7.66683 6.17592V3.66659Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6435b024f1ef0c8b358e8665155bf6b5.svg";
export { ForwardRef as ReactComponent };